import { useQuery } from '@tanstack/react-query';
// @mui material components
import Grid from '@mui/material/Grid';

// Material Dashboard 2 PRO React components
import MDBox from 'components/MDBox';

// API
import { getProductions } from 'services/api/production';

import CustomerSummary from 'layouts/production/Pages/All/Summary/Charts/CustomerDistribution.js';
import MonthlyProductionDistribution from 'layouts/production/Pages/All/Summary/Charts/MonthlyProductionDistribution.js';
import ActiveProductionsSummary from 'layouts/production/Pages/All/Summary/Charts/ActiveProductionsSummary.js';

const fetchProductions = async (productionType) => {
    const isActive = productionType === 'active' ? true : false;
    const response = await getProductions(`isActive=${isActive}`).then((rp) => rp.data.result);
    return response || [];
};

function Summary() {
    const {
        data: activeProductions = [],
        isLoading,
        error,
    } = useQuery({
        queryKey: ['fetchProductions', 'active'],
        queryFn: () => fetchProductions('active'),
        staleTime: 600000,
    });
    const passiveProductions = useQuery({
        queryKey: ['fetchProductions', 'passive'],
        queryFn: () => fetchProductions('passive'),
        staleTime: 600000,
    });

    if (isLoading) return '';
    if (passiveProductions.isLoading) return '';

    if (error) return 'Bir Hata Oluştu: ' + error.message;
    if (passiveProductions.error) return 'Bir Hata Oluştu: ' + passiveProductions.error.message;

    // Ensure both are arrays before spreading
    const activeProductionsArray = Array.isArray(activeProductions) ? activeProductions : [];
    const passiveProductionsArray = Array.isArray(passiveProductions.data) ? passiveProductions.data : [];
    const productions = [...activeProductionsArray, ...passiveProductionsArray];

    return (
        <MDBox>
            <MDBox mb={3}>
                <ActiveProductionsSummary activeProductions={activeProductionsArray} />
            </MDBox>
            <MDBox>
                <Grid container spacing={3}>
                    <Grid
                        size={{
                            xs: 12,
                            sm: 6,
                            lg: 4,
                        }}
                    >
                        <CustomerSummary productions={productions} />
                    </Grid>
                    <Grid
                        size={{
                            xs: 12,
                            sm: 6,
                            lg: 8,
                        }}
                    >
                        <MonthlyProductionDistribution productions={productions} />
                    </Grid>
                </Grid>
            </MDBox>
        </MDBox>
    );
}

export default Summary;
